<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
export default { name: 'App' }
</script>

<style>
:root {
  --brand: #2F88FF;
  --brand-light: #E8F2FF;
  --brand-dark: #1A6FE0;
  --success: #00B578;
  --warning: #FF943E;
  --danger: #FF4D4F;
  --text-primary: #171A1D;
  --text-secondary: #666B78;
  --text-tertiary: #A0A4AE;
  --text-white: #FFFFFF;
  --bg-page: #F5F6FA;
  --bg-card: #FFFFFF;
  --border-color: #E8E8EC;
  --shadow-card: 0 1px 4px rgba(0,0,0,0.06);
  --radius-card: 12px;
  --radius-btn: 8px;
}
* { margin: 0; padding: 0; box-sizing: border-box; -webkit-tap-highlight-color: transparent; }
html, body, #app {
  height: 100%;
  font-family: -apple-system, BlinkMacSystemFont, 'PingFang SC', 'Helvetica Neue', 'Microsoft YaHei', sans-serif;
  background: var(--bg-page);
  color: var(--text-primary);
  -webkit-font-smoothing: antialiased;
  font-size: 14px;
  line-height: 1.5;
}

/* Vant 主题覆盖 - 钉钉蓝色系 */
.van-nav-bar {
  background: var(--brand) !important;
}
.van-nav-bar__title {
  color: #fff !important;
  font-weight: 500 !important;
  font-size: 17px !important;
}
.van-nav-bar .van-icon { color: rgba(255,255,255,0.9) !important; }
.van-nav-bar__text { color: rgba(255,255,255,0.9) !important; }

.van-tabbar {
  background: #fff !important;
  border-top: 1px solid var(--border-color) !important;
}
.van-tabbar-item--active {
  color: var(--brand) !important;
  background: transparent !important;
}
.van-tabbar-item { color: var(--text-tertiary) !important; }

.van-button--primary {
  background: var(--brand) !important;
  border-color: var(--brand) !important;
}
.van-button--info {
  background: var(--brand) !important;
  border-color: var(--brand) !important;
}
.van-search__content {
  border-radius: 8px !important;
  background: #F5F6FA !important;
}
.van-search input { color: var(--text-primary) !important; }
.van-search input::placeholder { color: var(--text-tertiary) !important; }

.van-cell { font-size: 14px !important; }
.van-cell__title { color: var(--text-secondary) !important; }
.van-cell__value { color: var(--text-primary) !important; }

.van-dialog { border-radius: 14px !important; }
.van-dialog__header { color: var(--text-primary) !important; font-weight: 600 !important; }
.van-dialog__confirm { color: var(--brand) !important; }

.van-popup { border-radius: 14px 14px 0 0 !important; }
.van-action-sheet { border-radius: 14px 14px 0 0 !important; }
.van-action-sheet__header { color: var(--text-primary) !important; }

.van-tag--primary { background: var(--brand-light) !important; color: var(--brand) !important; border: none !important; }
.van-tag--success { background: #E8F8EF !important; color: var(--success) !important; border: none !important; }
.van-tag--danger { background: #FFE8EA !important; color: var(--danger) !important; border: none !important; }
.van-tag--warning { background: #FFF3E8 !important; color: var(--warning) !important; border: none !important; }

.van-field__control { color: var(--text-primary) !important; }
.van-field input::placeholder { color: var(--text-tertiary) !important; }
.van-stepper__input { background: #F5F6FA !important; color: var(--text-primary) !important; }
.van-stepper__minus, .van-stepper__plus { background: #F5F6FA !important; color: var(--brand) !important; }
.van-radio__label { color: var(--text-primary) !important; }
.van-tabs__line { background: var(--brand) !important; }
.van-tab--active { color: var(--brand) !important; }

.van-picker { border-radius: 14px 14px 0 0 !important; }
.van-picker__confirm { color: var(--brand) !important; }
.van-picker-column__item--selected { color: var(--text-primary) !important; font-weight: 600 !important; }
.van-picker-column__item { color: var(--text-tertiary) !important; }

.van-dropdown-menu__bar { background: #fff !important; box-shadow: none !important; }
.van-dropdown-menu__title { color: var(--text-secondary) !important; font-size: 13px !important; }
.van-dropdown-menu__title--active { color: var(--brand) !important; }
.van-dropdown-item__content { border-radius: 0 0 12px 12px !important; }
.van-dropdown-item__option--active { color: var(--brand) !important; }

.van-switch--on { background: var(--brand) !important; }

/* 通用钉钉风格组件 */
.dd-card {
  background: var(--bg-card);
  border-radius: var(--radius-card);
  padding: 16px;
  box-shadow: var(--shadow-card);
  margin: 0 16px 12px;
}
.dd-section-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);
  padding: 16px 16px 8px;
}
.dd-empty {
  text-align: center;
  padding: 60px 0;
  color: var(--text-tertiary);
  font-size: 14px;
}
</style>
